/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wallet_Card_Expiry_DateInputs */

const en_wallet_card_expiry_date = /** @type {(inputs: Wallet_Card_Expiry_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expiry Date`)
};

const fr_wallet_card_expiry_date = /** @type {(inputs: Wallet_Card_Expiry_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date d'expiration`)
};

/**
* | output |
* | --- |
* | "Expiry Date" |
*
* @param {Wallet_Card_Expiry_DateInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const wallet_card_expiry_date = /** @type {((inputs?: Wallet_Card_Expiry_DateInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wallet_Card_Expiry_DateInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wallet_card_expiry_date(inputs)
	return fr_wallet_card_expiry_date(inputs)
});